module.exports = __webpack_public_path__ + "img/gao_one.180748a7.png";